import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import { compose } from "recompose";
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActionCreator from './../../../store/actions/index';
import { Collapse, TableCell, TableRow } from '@material-ui/core';
import CarDetails from './CarDetails';
import moment from 'moment-timezone';
import NoData from './../../Common/NoDataRow';
import { notArrayOrEmpty } from '../../../utils/helpers';
import CarDetailsRow from "./CarDetailsRow";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import styles from "./styles";
import { displayDateTimeFormat } from '../../../utils/staticData';
import EcoChartDialog from "../../Utilities/EcoChart/EcoChartDialog";
import { SET_CAR } from "../../../store/types";
import CarStatusLabel from "./CarStatusLabel";

const TableRows = props => {
    const { cars, chartData } = props;
    const [open, setOpen] = useState(null);
    const classes = styles();
    const [openChart, setOpenChart] = useState(false);
    const [carChartInfo, setCarChartInfo]  = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        props.getCarsDetails();
        props.getRentPricing();
        props.getCarPossibleParameters();
    }, []);

    useEffect(() => {
        if(cars.length === 1) {
          setOpen(cars[0].auto_id);
          dispatch({type: SET_CAR, value: cars[0]});
        }
    }, [cars]);

    const handleEcoGradeClick = (id, brand, model, registrationNo) => {
        props.getCarEcoChart(id);
        setCarChartInfo({
            brand: brand,
            model: model,
            registrationNo: registrationNo
        });
        setOpenChart(true);
    };

    const handleChartClose = () => {
        props.cleanCarChartData();
        setOpenChart(false);
    };

    const handleRemoveGroupFromCar = (groupId, carId) => {
        props.removeCarFromGroup(groupId, carId);
    };

    const handleRowClick = car => {
        dispatch({type: SET_CAR, value: car});
        if (car.auto_id !== open) {
            setOpen(car.auto_id);
        }
        else {
            setOpen("");
        }
    };

    const listRows = (data) => {
        if (notArrayOrEmpty(data))
            return <NoData colSpan={13} />;
        return data.map(car => {
            return (
                <React.Fragment key={car.auto_id} >
                    <CarDetailsRow
                        classes={{row: classes.row, cell: classes.cell}}
                        registrationNo={car.rejestracja}
                        archived={car.zarchiwizowane}
                        brand={car.marka}
                        model={car.model}
                        description={car.opis}
                        service={car.serwis}
                        blocade={car.blokada}
                        gprs={<CarStatusLabel status={car.stan_gps} />}
                        poi={car.POI}
                        ecoGrade={car.eco}
                        fuelLevel={car.stan_paliwa}
                        fuelTypeId={car.paliwo_id}
                        fuelReserve={car.rezerwa}
                        batteryCondition={car.stan_akumulatora}
                        //fuelUsage={car.oczekiwane_sr_spalanie}
                        meterReading={car.dystans}
                        state={car.stan_wynajem}
                        lastCellContent={open === car.auto_id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        opened={open === car.auto_id}
                        onRowClick={handleRowClick.bind(this, car)}
                        onEcoGradeClick={handleEcoGradeClick.bind(this, car.auto_id, car.marka, car.model, car.rejestracja)}
                    />
                    <TableRow>
                        <TableCell style={{ padding: 0 }} colSpan={13}>
                            <Collapse
                                in={open === car.auto_id}
                                unmountOnExit
                            >
                                <CarDetails
                                    id={car.auto_id}
                                    car={car}
                                    carType={car.typ}
                                    registrationNo={car.rejestracja}
                                    vin={car.vin}
                                    phoneNo={car.telefon}
                                    password={car.haslo}
                                    description={car.opis}
                                    fuelLevel={car.stan_paliwa}
                                    fuelType={car.paliwo}
                                    fuelTypeId={car.paliwo_id}
                                    meterReading={car.dystans}
                                    serialNo={car.serial}
                                    gpsState={car.stan_gps}
                                    lastComm={moment.unix(car.stan_gps_data).format(displayDateTimeFormat)}
                                    email={car.email}
                                    groups={car.grupy}
                                    batteryCondition={car.stan_akumulatora}
                                    onGroupDelete={handleRemoveGroupFromCar}
                                />
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </React.Fragment>
            );
        });
    };

    return (
        <React.Fragment>
            {listRows(cars)}
            <EcoChartDialog
                open={openChart}
                onClose={handleChartClose}
                isCar
                data={chartData}
                carData={carChartInfo}
            />
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        chartData: state.carsReducer.ecoChart
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};

TableRows.propTypes = {
    cars: PropTypes.array,
    //redux
    chartData: PropTypes.array,
    getCarsDetails: PropTypes.func,
    getRentPricing: PropTypes.func,
    removeCarFromGroup: PropTypes.func,
    getCarEcoChart: PropTypes.func,
    cleanCarChartData: PropTypes.func,
    getCarPossibleParameters: PropTypes.func,
    //router
    match: PropTypes.object,
};

TableRows.defaultProps = {
    cars: []
};

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(TableRows);
